import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Shield, Server, Network, KeyRound, Lock, Check } from "lucide-react";

const iconMap = { Shield, Server, Network, KeyRound, Lock };

function CheckList({ items }) {
  return (
    <ul className="mt-3 space-y-2.5 text-sm text-slate-700">
      {items?.map((d, i) => (
        <li key={i} className="flex items-start gap-2.5">
          <span className="mt-0.5 grid h-4 w-4 shrink-0 place-items-center rounded-full bg-[rgba(40,216,255,0.18)]">
            <Check size={11} strokeWidth={3} className="text-[#002D72]" />
          </span>
          {d}
        </li>
      ))}
    </ul>
  );
}

export default function ServiceDialog({ open, onOpenChange, service, onScrollTo }) {
  if (!service) return null;
  const Icon = iconMap[service.icon] || Shield;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="service-dialog" className="sm:max-w-2xl border-slate-200 bg-white p-0 overflow-hidden animate-in fade-in-50 zoom-in-95">
        {/* Header band */}
        <div className="relative overflow-hidden px-7 pt-7 pb-6" style={{ background: "linear-gradient(135deg, #0A111F 0%, #002D72 130%)" }}>
          <div className="pointer-events-none absolute -top-12 -right-8 h-44 w-44 rounded-full" style={{ background: "radial-gradient(circle, rgba(40,216,255,0.25), rgba(40,216,255,0) 70%)" }} />
          <DialogHeader className="relative">
            <div className="flex items-start gap-4">
              <div className="grid h-12 w-12 shrink-0 place-items-center rounded-xl border border-white/15 bg-white/10 text-[#28D8FF]">
                <Icon size={22} />
              </div>
              <div className="text-left">
                <DialogTitle className="font-display text-2xl text-white">{service.title}</DialogTitle>
                <DialogDescription className="mt-1 text-slate-300">{service.punchline}</DialogDescription>
              </div>
            </div>
          </DialogHeader>
        </div>

        <div className="space-y-6 px-7 pb-7 pt-5">
          <p className="leading-relaxed text-slate-700">{service.details?.intro}</p>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div className="rounded-2xl bg-[#F4F6F8] p-5">
              <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-[#002D72]">Deliverables</div>
              <CheckList items={service.details?.deliverables} />
            </div>
            <div className="rounded-2xl bg-[#F4F6F8] p-5">
              <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-[#002D72]">Vorgehen</div>
              <CheckList items={service.details?.process} />
            </div>
          </div>
          <div className="flex flex-wrap gap-3">
            <Button
              data-testid="service-dialog-cta"
              onClick={() => { onOpenChange(false); onScrollTo("kontakt"); }}
              className="rounded-full font-semibold shadow-sm transition-shadow hover:shadow-[0_0_22px_rgba(40,216,255,0.45)]"
              style={{ backgroundColor: "#28D8FF", color: "#063247" }}
            >
              Unverbindliches Erstgespräch
            </Button>
            <Button data-testid="service-dialog-close" variant="outline" onClick={() => onOpenChange(false)} className="rounded-full border-slate-300 text-slate-700">
              Schliessen
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
